import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestaurantProfile } from '../../models/List.Restaurant';
import { RestaurantService } from '../../services/Restaurant.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  dataLoading = false;

  // Nav scrollable
  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider!: any;

  // Restaurant ID
  restaurantId?: any;
  restaurantProfile?: RestaurantProfile;
  lang = localStorage.getItem('language') || 'en';
  isShown?: boolean = false;

  currentURL?: any;
  active?: boolean;

  activeSiteSection?: string;

  headerOffset = 150;
  activeIndex = 0;
  tabs = [
    { name: this.translate.instant('restaurant.Basic Info'), index: 0 }, //0
    { name: this.translate.instant('restaurant.Photos & Videos'), index: 1 }, //1
    { name: this.translate.instant('content3.Amenities'), index: 2 }, //2
    // { name: this.translate.instant('restaurant.Staff'), index: 3 }, //3
    // { name: this.translate.instant('content.Reservations'), index: 4 }, //4
    // { name: this.translate.instant('restaurant.Reviews'), index: 5 }, //5
    // { name: this.translate.instant('restaurant.Events'), index: 6 }, //6
    // { name: this.translate.instant('restaurant.Guest Announcements'), index: 7 }, //7
    { name: this.translate.instant('content.Payment Methods'), index: 3 }, //3
    { name: this.translate.instant('restaurant.Cancellation & Refund Policies'), index: 4 }, //4
    { name: this.translate.instant('restaurant.Reservation Channels'), index: 5 }, //5
  ];

  isMainProfile = true;
  publishStatus: any;
  currentAttandanceFeature = false;
  attandanceFeatureLoader = false;

  subscriberDetails!: Subscription;
  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private service: RestaurantService,
    public translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });
    if (this.restaurantId) {
      this.isMainProfile = false;
    } else {
      this.tabs = this.tabs.splice(0, 3)
    }
  }

  ngOnInit(): void {
    this.GetRestaurantProfile();
    this.service.refreshDetails.next(false);
    this.subscriberDetails = this.service.refreshDetails.subscribe(data => {
      if (data) {
        this.GetRestaurantProfile()
      }
    })
  }
  ngOnDestroy(): void {
    this.subscriberDetails.unsubscribe();
  }
  // ngAfterViewInit() {
  //   this.slider = document.querySelector<HTMLElement>('.nav-tabs');
  // }
  initSlider() {
    this.slider = document.querySelector<HTMLElement>('.nav-tabs');
  }
  startDragging(e?: any, flag?: any) {
    this.mouseDown = true;
    this.startX = e.pageX - this.slider!.offsetLeft;
    this.scrollLeft = this.slider!.scrollLeft;
  }
  stopDragging(e?: any, flag?: any) {
    this.mouseDown = false;
  }
  moveEvent(e?: any) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - this.slider!.offsetLeft;
    const scroll = x - this.startX;
    this.slider!.scrollLeft = this.scrollLeft - scroll;
  }

  GetRestaurantProfile() {
    this.dataLoading = true;
    this.service.GetRestaurantProfile(this.restaurantId).subscribe((data: RestaurantProfile) => {
      this.dataLoading = false;
      if (data.id) {
        this.restaurantProfile = data
        this.restaurantId = this.restaurantProfile.id;
        this.publishStatus = this.restaurantProfile.publishStatus;
        this.currentAttandanceFeature = this.restaurantProfile.attandanceFeature;
        setTimeout(() => {
          this.initSlider();
        }, 100);
      } else {
        this.router.navigate(['/admin/404'])
      }
    },
      (error: any) => {
        this.dataLoading = false;
        this.restaurantProfile = undefined;
      });
  }

  navigateToSection(event: any, index: number) {
    event.preventDefault();
    let container = document.getElementById('tab-' + index) as HTMLElement;
    if (container) {
      const elementPosition = container.offsetTop
      const offsetPosition = elementPosition - this.headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  @HostListener('window:scroll', ['$event']) onScroll(event: Event) {
    let cloneTabs: [] = JSON.parse(JSON.stringify(this.tabs));
    cloneTabs.reverse().forEach((element: any) => {
      this.isVisible(element.index);
    });
  }

  isVisible(index: number) {
    const ele = document.getElementById('tab-' + index) as HTMLElement;
    if (!ele) return;
    const { top, bottom } = ele.getBoundingClientRect();
    const vHeight = (window.innerHeight || document.documentElement.clientHeight);

    // const inView = ((top > 0 || bottom > 0) && top < vHeight );
    let headerOffset = this.headerOffset - 5
    const inView = (
      (top > headerOffset && bottom > headerOffset)
      && top < (vHeight / 2)
    );
    if (inView) {
      this.activeIndex = index;
      if (index > 5) {
        document.querySelector<HTMLElement>('.nav-tabs')!.scrollLeft
          = document.querySelector<HTMLElement>('.nav-tabs')!.scrollWidth;
      } else {
        document.querySelector<HTMLElement>('.nav-tabs')!.scrollLeft = 0
      }
    }
    return inView;
  }

  changeAttendance() {
    this.attandanceFeatureLoader = true;
    let data = {
      restaurantId: this.restaurantId,
      active: this.restaurantProfile?.attandanceFeature
    }
    this.service.SaveAttandanceFeature(data).subscribe((resp: any) => {
      this.attandanceFeatureLoader = false;
      if (!resp) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: resp.errorMessages[0],
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      }
    }, error => {
      this.attandanceFeatureLoader = false;
      this.restaurantProfile!.attandanceFeature = this.currentAttandanceFeature;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    })
  }
}
